module.exports = {
  locale: 'zh-CN',
  messages: {
    'app.header.menu.home': '首页',
    'app.header.menu.language': '文档',
    'app.header.menu.edit': '编辑器',
    'app.home.introduce': '86links Landing 平台拥有丰富的各类首页模板，下载模板代码包，即可快速使用，也可使用首页编辑器，快速搭建一个属于你的专属首页',
    'app.home.select-template': '丰富模板',
    'app.home.enter-editor': '进入编辑器',
    'app.home.module': '丰富的模块',
    'app.home.features': '三大特征',
    'app.home.fatures.language': '设计指引',
    'app.home.fatures.sketch': 'Sketch 资源包',
    'app.home.fatures.responsive': '响应式布局',
    'app.home.templates': '丰富的模板',
    'app.home.preview': '预览',
    'app.home.edit': '编辑',
    'app.home.download': '下载',
    'app.home.edit-slogen': '所有模板与模块都基于设计规范设计，你可以直接下载我们的模板和源文件，也可使用我们的编辑器，快速搭建一个属于你的专属首页',
    'app.content.edit-page': '在 Github 上编辑此页！',
    'app.layout.notification.title': '关注下 Star 数',
    'app.layout.notification.content': '我们需要您的支持，请点击按钮帮助我们增加 github star。',
  },
};
